import React, { useContext } from 'react';
import { useTranslation } from 'react-i18next';
import EmployeeLimitBanner from '../components/EmployeeLimitBanner';
import { UserContext } from '../context/UserContext';
import { UserManagementTable, btnSecondary } from '@redpanda/ui';
import { formatTableDate } from '@redpanda/utils';
import { getApprovedUsers, getPendingUsers, updateUserRole, deleteUser, approveUser, rejectUser } from '../services/api';
import { isSubscriptionEnabled } from '../utils/environment';

// 使用者管理表（@redpanda/ui 共用，R26）呼叫的 API
const userManagementApi = { getApprovedUsers, getPendingUsers, updateUserRole, deleteUser, approveUser, rejectUser };

/** 管理員面板（路由限 SUPER_ADMIN，App.tsx） */
const AdminPage: React.FC = () => {
  const { t } = useTranslation();
  const userContext = useContext(UserContext);

  return (
    <div className="container mx-auto px-10 py-6 pb-32">
      <h1 className="text-2xl font-semibold text-gray-900 dark:text-white mb-6">{t('adminPanel.title', { ns: 'pages' })}</h1>

      {/* 員工數量使用情況 */}
      <EmployeeLimitBanner showAlways={true} />

      <div className="mb-8">
        <h2 className="text-base font-semibold text-fg mb-3">{t('adminPanel.userManagement', { ns: 'pages' })}</h2>
        <UserManagementTable api={userManagementApi} currentUser={userContext?.user} formatDate={formatTableDate} />
      </div>

      {/* HR 沒有資料匯入匯出頁（原本的連結會被導回首頁），只留訂閱管理 */}
      {isSubscriptionEnabled() && (
        <section className="bg-surface rounded-lg border border-line p-5 md:max-w-[50%]">
          <h2 className="text-base font-semibold text-fg mb-1">{t('adminPanel.subscriptionManagement', { ns: 'pages' })}</h2>
          <p className="text-sm text-fg-secondary mb-4">{t('adminPanel.subscriptionDescription', { ns: 'pages' })}</p>
          <a
            href={`${process.env.REACT_APP_ACCOUNT_PORTAL_URL || 'http://localhost:8003'}/hr`}
            target="_blank"
            rel="noopener noreferrer"
            className={btnSecondary}
          >
            {t('common.navigation.manageSubscription')}
          </a>
        </section>
      )}
    </div>
  );
};

export default AdminPage;
